import React, { Component } from 'react';

import Card from '@material-ui/core/Card';
import Typography from '@material-ui/core/Typography';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import ErrorIcon from '@material-ui/icons/Error';
import PrintIcon from '@material-ui/icons/Print';
import CameraAltIcon from '@material-ui/icons/CameraAlt';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next';
import CardContent from "@material-ui/core/CardContent/CardContent";
import { Link } from 'react-router-dom';
import { PhotoModeContext } from '../contexts/PhotoModeContext';

const styles = {
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  infoSection: {
    display: 'flex',
    alignItems: 'center',
    flex: 1
  },
  avatar: {
    marginRight: '20px',
    height: '60px',
    width: '60px',
  },
  photoAvatar: {
    marginRight: '20px',
    height: '60px',
    width: '60px',
    background: 'conic-gradient(from 0deg, #00aaff, #ff00aa, #ffaa00, #00aaff)',
  },
  formatInfo: {
    background: '#f2f2f2',
    padding: '10px',
    borderRadius: '5px',
    marginBottom: '-10px',
    marginTop: '10px',
  }
};

class PrinterBasicInfo extends Component {
  // Helper method to determine if we're in photo mode
  isPhotoMode() {
    return this.context && this.context.isPhotoMode;
  }

  render() {
    const { classes, t, printer, onSelectPrinter, allowPrinterChange, orderLoaded } = this.props;

    const address = printer ? printer.address : t('printerAddress');
    const name = printer ? printer.name : t('printerName');
    const link = printer ? `/printers/${printer.id}` : '#'
    const showChangeLink = printer && onSelectPrinter && allowPrinterChange;

    // Choose icon based on photo mode from context
    const getIcon = () => {
      if (printer && !printer.enabled) {
        return <ErrorIcon/>;
      }

      return this.isPhotoMode() ? <CameraAltIcon/> : <PrintIcon/>;
    };

    return(
        <Card>
          <CardContent>
            <div className={classes.container}>
              <div className={classes.infoSection}>
                {printer && printer.locationLogoId &&
                <img src={process.env.REACT_APP_STORAGE_URL + '/' + printer.locationLogoId} style={{height: 60, marginRight: 20}} alt={name}/>
                }

              {(!printer || !printer.locationLogoId) &&
                <Avatar className={this.isPhotoMode() ? classes.photoAvatar : classes.avatar}>
                  {getIcon()}
                </Avatar>
              }
              <div>
                <Typography
                  component="h3"
                  type="headline"
                  data-cy="basicInfo.printerName"
                >
                  <Link to={link} color="inherit">
                    {name}
                  </Link>
                  {showChangeLink &&
                  <>
                    {' ('}
                    <Link
                      to="#"
                      color="inherit"
                      onClick={(e) => {
                        e.preventDefault();
                        onSelectPrinter();
                      }}
                    >
                      {t('change')}
                    </Link>
                    {')'}
                  </>
                  }
                </Typography>
                <Typography color="primary">
                    {address}
                </Typography>
              </div>
              </div>
              {!printer && onSelectPrinter && orderLoaded &&
                <Button
                  variant="contained"
                  color="primary"
                  onClick={onSelectPrinter}
                >
                  {t('choosePrinter')}
                </Button>
              }
            </div>
            { this.isPhotoMode() &&
              <div className={classes.formatInfo}>
                <Typography variant="body2">
                  {t('formatInfo.Photo')}
                </Typography>
              </div>
            }
          </CardContent>
        </Card>
    );
  }
}

// Add context type for PhotoModeContext
PrinterBasicInfo.contextType = PhotoModeContext;

export default withStyles(styles)(withTranslation()(PrinterBasicInfo));
